import styled from "styled-components";
import BaseCardCreate from "../../common/CardCreate";

export const CardCreate = styled(BaseCardCreate)`
  min-height: 21rem;
`;
